<!--
* 页面名 : 首页
* 开发者 : lh
* 问题,  2张资源图,  1个翻译, v-lity 组件 v-Scrolldown 组件
-->
<template>
  <section class="home" v-slide-up-in>
    <v-background
      :src="['images/home/starry-sky.jpg', 'images/home/earth.png']"
      :slide-up-in="true"
    />
    <div class="home-content" v-slide-up-in-stage="3">
      <v-img path="loading/title.png"></v-img>
      <siteBtn />
    </div>
    <Nav :navData="navData" v-slide-up-in-stage="2" />
    <stageNav v-slide-up-in-stage="4" />
  </section>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { load_fonts } from "@/views/home/helper";
import "./index.scss";

import Nav from "./components/nav/index.vue";
import stageNav from "./components/stage-nav/index.vue";
import siteBtn from "./components/site-btn/index";
import VScrollNext from "@/framework/components/VScrollNext";

export default {
  name: "home",
  components: {
    VScrollNext,
    Nav,
    stageNav,
    siteBtn,
  },
  computed: {
    ...mapState("global", ["schema"]),
    ...mapGetters("global", ["logo"]),
  },
  data: () => {
    return {
      navData: {},
    };
  },
  created() {
    this.navData.logo = this.logo;
    this.navData.data = this.schema["home"].item.nav.data;
    this.$P.$on("loadingFinish", () =>
      $(window).one("mousemove", () => load_fonts())
    );
  },
  methods: {},
};
</script>
